module.exports = __webpack_public_path__ + "static/media/python-5.146716bd.svg";